<template>
  <div class="app-notification-bar">
    <slot tag="span"/>
  </div>
</template>

<script>
export default {
  // Name
  name: 'app-notification-bar',

  // Props
  props: {
    confirmationNumber: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped lang="scss">
.app-notification-bar {
  height: 25px;
  background-color: $brand-color-primary;
  font-size: 10px;
  font-weight: 600;
  color: #fff;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  @include breakpoint('tablet-portrait-up') {
    // margin: 60px 0;
    height: 36px;
    font-size: 15px;
  }
}
</style>
